import React from "react";

const Help: React.FC = () => {
    return (
        <div>
            Help
        </div>
    );
}

export default Help;